import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import sociallink from "../Images/sociallink.svg";
const Sociallinks = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b> - boost your SEO
            game&nbsp;&nbsp;
            <Button size="sm" variant="success">
              Know More
            </Button>
          </p>
        </div> */}
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 ">
          <div className="mx-2">
            <h1>
              Boost Your Social Media With The Best Social Links Generator
            </h1>

            <p>
              These days, in a digital environment, you have to ensure that your
              content is shareable to increase your audiences and engagement.
              The Social Links Generator is the perfect tool for the whole
              process, allowing you to create customized and clickable links for
              all platforms; thus, followers can share your content with one
              single click.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className=""
                src={sociallink}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <h2>What Is A Social Links Generator?</h2>

            <p>
              This wonderful portal, the Social Links Generator, supports URLs
              to interfuse your content for effortless sharing on a long list of
              platforms, including Facebook, Twitter, Instagram, LinkedIn,
              Pinterest, WhatsApp, Telegram, and more-blogging and video content
              included. With such tools you can save time instead of manually
              having to imagine links for each network and make sure every
              channel of yours is catered to equally since the link generation
              is done in an automated manner.
            </p>

            <h3>Why Use a Social Links Generator?</h3>

            <ul>
              <li>
                <strong>One-Click Sharing</strong>: Instantly generate share
                links for all major social networks, making it easy for your
                audience to spread your content far and wide.
              </li>
              <li>
                <strong>Customizable & Trackable</strong>: Personalize your
                links and monitor their performance to see which platforms drive
                the most engagement.
              </li>
              <li>
                <strong>Brand Consistency</strong>: Auto-populate your links
                with your website’s title, description, and images, ensuring
                every share looks professional and on-brand.
              </li>
              <li>
                <strong>No Coding Required</strong>: User-friendly interfaces
                mean anyone can create and implement share links—no technical
                skills needed.
              </li>
              <li>
                <strong>Multi-Platform Reach</strong>: From WhatsApp and
                Telegram to Facebook, Twitter, and LinkedIn, reach your audience
                wherever they are.
              </li>
            </ul>

            <h4>Who Should Use a Social Links Generator?</h4>

            <ul>
              <li>Content creators and bloggers wanting to maximum reach.</li>
              <li>
                Businesses aiming to increase brand visibility and engagement.
              </li>
              <li>
                Social media managers seeking efficient cross-platform
                promotion.
              </li>
              <li>
                Anyone looking to make their content go viral with minimal
                effort.
              </li>
            </ul>

            <h3>Get Started Today</h3>

            <p>
              Don’t let your content sit idle—make it easy for your audience to
              share and amplify your message. With tools like SeoBix or browser
              extensions such as Social Link Generator, you can create powerful,
              trackable social links in seconds.
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Sociallinks;
